import { MenuList as MenuListCore } from '@studiometa/ui';

/**
 * MenuList class.
 */
export default class MenuList extends MenuListCore {
  /**
   * Config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'MenuList',
  };
}
